import type { CSSProperties } from "react";
import NumberFlow, {
  type NumberFlowProps,
  usePrefersReducedMotion,
} from "@number-flow/react";
import type { NumericMotionPolicyInput } from "../../lib/numbers/numeric-motion-policy";
import { shouldAnimateNumericValue } from "../../lib/numbers/numeric-motion-policy";

export interface FintheonNumberProps extends NumericMotionPolicyInput {
  value: number;
  format?: NumberFlowProps["format"];
  locales?: NumberFlowProps["locales"];
  prefix?: string;
  suffix?: string;
  className?: string;
  style?: CSSProperties;
  title?: string;
  trend?: NumberFlowProps["trend"];
}

export function FintheonNumber({
  value,
  format,
  locales,
  prefix,
  suffix,
  className,
  style,
  title,
  trend,
  ...policy
}: FintheonNumberProps) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const shouldAnimate =
    shouldAnimateNumericValue(policy) && !prefersReducedMotion;

  if (!shouldAnimate) {
    const formatted = new Intl.NumberFormat(locales, format).format(value);
    return (
      <span className={className} style={style} title={title}>
        {prefix}
        {formatted}
        {suffix}
      </span>
    );
  }

  return (
    <NumberFlow
      value={value}
      format={format}
      locales={locales}
      prefix={prefix}
      suffix={suffix}
      className={className}
      style={style}
      title={title}
      trend={trend}
      animated
      respectMotionPreference
      willChange
    />
  );
}
